import { render, staticRenderFns } from "./abandoned-deposit-detail.vue?vue&type=template&id=c0ccc50a"
import script from "./abandoned-deposit-detail.vue?vue&type=script&lang=js"
export * from "./abandoned-deposit-detail.vue?vue&type=script&lang=js"
import style0 from "./abandoned-deposit-detail.vue?vue&type=style&index=0&id=c0ccc50a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ccc50a')) {
      api.createRecord('c0ccc50a', component.options)
    } else {
      api.reload('c0ccc50a', component.options)
    }
    module.hot.accept("./abandoned-deposit-detail.vue?vue&type=template&id=c0ccc50a", function () {
      api.rerender('c0ccc50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/abandoned/abandoned-deposit-detail.vue"
export default component.exports